import { render, staticRenderFns } from "./Contributor.vue?vue&type=template&id=3334ba32&"
import script from "./Contributor.vue?vue&type=script&lang=js&"
export * from "./Contributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports